// File: hooks/useMilestoneProgress.ts
import { useCallback, useState } from 'react';

export interface MilestoneOptions {
  milestones?: number[]; // default: [25, 50, 75, 100]
  onTrigger?: (milestone: number) => void;
}

export const useMilestoneProgress = ({
  milestones = [25, 50, 75, 100],
  onTrigger,
}: MilestoneOptions = {}) => {
  const [triggered, setTriggered] = useState<Set<number>>(new Set());

  const handleProgress = useCallback(
    (percent: number) => {
      milestones.forEach((milestone) => {
        if (percent >= milestone && !triggered.has(milestone)) {
          setTriggered((prev) => new Set(prev).add(milestone));
          onTrigger?.(milestone);
        }
      });
    },
    [milestones, triggered, onTrigger]
  );

  return {
    triggeredMilestones: Array.from(triggered),
    handleProgress,
    hasTriggered: (value: number) => triggered.has(value),
  };
};
